export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'Match - 个人中心',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://match.black9.cn/',
    pro: '/'
  },
  proxyTable: {
    '/v2api': {
      target: 'http://match.black9.cn/',
      changeOrigin: true, // 开启代理
      // pathRewrite: {
      //   '^/v2api': '/v2api'
      // }
    }
  },
  accessToken: 'm_user_token',
  matchHost: process.env.NODE_ENV === 'production'?'http://match.haai.net/':'http://match.black9.cn/'
}
